import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import useNawiChat from './useNawiChat';

const NawiChatActionsContext = createContext(null);
const NawiChatComposerContext = createContext(null);
const NawiChatConversationContext = createContext(null);

const useRequiredContext = (context, name) => {
  const value = useContext(context);

  if (!value) {
    throw new Error(`${name} must be used within NawiChatProvider`);
  }

  return value;
};

export const useNawiChatActions = () =>
  useRequiredContext(NawiChatActionsContext, 'useNawiChatActions');

export const useNawiChatComposer = () =>
  useRequiredContext(NawiChatComposerContext, 'useNawiChatComposer');

export const useNawiChatConversation = () =>
  useRequiredContext(NawiChatConversationContext, 'useNawiChatConversation');

const NawiChatProvider = ({ accountId, children, userPlayerId }) => {
  const { actions, composer, conversation } = useNawiChat({
    accountId,
    userPlayerId,
  });

  return (
    <NawiChatActionsContext.Provider value={actions}>
      <NawiChatComposerContext.Provider value={composer}>
        <NawiChatConversationContext.Provider value={conversation}>
          {children}
        </NawiChatConversationContext.Provider>
      </NawiChatComposerContext.Provider>
    </NawiChatActionsContext.Provider>
  );
};

NawiChatProvider.propTypes = {
  accountId: PropTypes.number,
  children: PropTypes.node.isRequired,
  userPlayerId: PropTypes.number,
};

export default NawiChatProvider;
